<script lang="ts">
import { defineComponent } from 'vue';
import NavigationInnerHead from 'components/User/NavigationInnerHead.vue';
import AddressManager from 'components/User/Addresses/AddressManager.vue';

export default defineComponent({
  name: 'Addresses',

  components: {
    NavigationInnerHead,
    AddressManager,
  },
});
</script>

<template>
  <q-card class="bg-transparent shadow-0">
    <div class="flex justify-between items-center q-mb-md">
      <div>
        <navigation-inner-head title="Addresses" icon="contacts" />
      </div>
      <div></div>
    </div>
    <q-separator color="accent" />
    <div class="row">
      <div class="col-12 row q-py-lg">
        <div class="container">
          <address-manager />
        </div>
      </div>
    </div>
  </q-card>
</template>

<style scoped></style>
